import React from 'react'
// import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet-async";

function ProductDetail() {
    // const [active, setActive] = useState("Safe Area");
    // const navigate = useNavigate();


    const clients = [
        {
            img: "/assets/services/enclosures.svg",
            title: "IP66/67/68 Weather Proof Enclosures",
            text: "IP66/67/68 rated UV-resistant Weather Proof Polycarbonate, Aluminium, FRP & ABS enclosures offered in various sizes, with and without terminals.",
            link: "/services/enclosures"
        },
        {
            img: "/assets/services/ip68-gel-filled-connectors.svg",
            title: "IP68 Gel Filled Connectors",
            text: "Available in straight and branch formations to suit cables from 0.5mm² to 6mm², ensuring reliable and waterproof electrical connections.",
            link: "/services/ip68-gel-filled-connectors"
        },
        {
            img: "/assets/services/ip68-silicone-gel.svg",
            title: "Re-enterable Gel",
            text: "Standard pack sizes of 1 liter and 10 liters available with light blue gel color, providing durable insulation and moisture protection.",
            link: "/services/ip68-bi-component-silicone-gel"
        },
        {
            img: "/assets/services/power-control-cables.svg",
            title: "Cable Glands &amp; Ventilation Devices",
            text: "LV, Instrumentation, Earthing, Control, and Rubber Flexible cables designed for efficient power distribution and reliable operation of lights and pumps.",
            link: "/services/power-control-rubber-cables"
        },
        {
            img: "/assets/services/conduits-fittings.svg",
            title: "Waterproof Tapes",
            text: "Rigid and flexible conduits with accessories for pump rooms, irrigation, and electrical installations — available in uPVC and galvanized iron.",
            link: "/services/conduits-fittings"
        },
        {
            img: "/assets/services/glands-lugs-tapes.svg",
            title: "Wiring Terminals",
            text: "Reliable termination, glanding, and sealing accessories to secure cables and joints safely, ensuring power integrity and protection.",
            link: "/services/glands-lugs-waterproof-tapes"
        }
        ,
        {
            img: "/assets/services/glands-lugs-tapes.svg",
            title: "H07RN-F Rubber Flexibles",
            text: "Reliable termination, glanding, and sealing accessories to secure cables and joints safely, ensuring power integrity and protection.",
            link: "/services/glands-lugs-waterproof-tapes"
        },
            {
            img: "/assets/services/glands-lugs-tapes.svg",
            title: "Power, Instrumentation &amp; Control Cables",
            text: "Reliable termination, glanding, and sealing accessories to secure cables and joints safely, ensuring power integrity and protection.",
            link: "/services/glands-lugs-waterproof-tapes"
        },
            {
            img: "/assets/services/glands-lugs-tapes.svg",
            title: "Cable Tray &amp; Conduits",
            text: "Reliable termination, glanding, and sealing accessories to secure cables and joints safely, ensuring power integrity and protection.",
            link: "/services/glands-lugs-waterproof-tapes"
        },
            {
            img: "/assets/services/glands-lugs-tapes.svg",
            title: "In-Ground Power Unit",
            text: "Reliable termination, glanding, and sealing accessories to secure cables and joints safely, ensuring power integrity and protection.",
            link: "/services/glands-lugs-waterproof-tapes"
        },
    ];

    return (
        <>
        <Helmet>
    <title>
        Landscape Electrical Solutions & IP68 Products UAE | Al Ibtekar
    </title>

    <meta
        name="description"
        content="Al Ibtekar provides reliable electrical wiring, termination and IP66, IP67, IP68 and IP69 solutions for landscaping, swimming pools, lakes, ponds, fountains and outdoor applications across the UAE."
    />

    <meta
        name="keywords"
        content="landscape electrical solutions UAE, landscape lighting solutions UAE, IP68 electrical solutions UAE, swimming pool electrical products UAE, fountain electrical solutions UAE, waterproof cable connectors UAE, IP68 gel connectors UAE, outdoor electrical solutions UAE, landscape lighting electrical products"
    />

    <link
        rel="canonical"
        href="https://saig.me/landscape"
    />

    <meta
        property="og:title"
        content="Landscape Electrical Solutions & IP68 Products UAE | Al Ibtekar"
    />

    <meta
        property="og:description"
        content="IP66, IP67, IP68 and IP69 electrical wiring and termination solutions for landscaping, swimming pools, water bodies, fountains and outdoor applications in the UAE."
    />

    <meta
        property="og:url"
        content="https://saig.me/landscape"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:site_name"
        content="Al Ibtekar"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="Landscape Electrical Solutions & IP68 Products UAE | Al Ibtekar"
    />

    <meta
        name="twitter:description"
        content="Reliable waterproof electrical and cable termination solutions for landscaping, pools, fountains and outdoor applications across the UAE."
    />
</Helmet>
            <div className='newbanner-about newbanner-about3'>
                <div className='max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]'>
                    <h6 className="font-[500] font-kanit lg:text-[60px] text-[30px] lg:leading-[90px] leading-[40px] text-[#FFFFFF] lg:pb-[14px] pb-[4px]">Landscape</h6>
                    <p className="lg:max-w-[582px] max-w-[250px] w-full font-[300] font-inter lg:text-[20px] text-[12px] lg:leading-[30px] leading-[16px] text-[#FFFFFF]">Transforming outdoor spaces with smart, sustainable solutions.
                    </p>
                </div>
            </div>
         
    <div className='newbg'>

               <div className='max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] overflow-hidden allheader mb-[20px]'>
  <h2>Landscape</h2>
  <div className='line'></div>
                         <h3 className='text-left'>Lighting design and illumination is an art, its implementation requires intricate planning. The proper selection of IP rated electrical & termination joints ensures that the lighting fixtures gives the intended light output without disruptions whether it’s an underwater, dry or humid area application.

Our product range supports all forms of landscaping & water bodies:</h3>

               </div>
               </div>


            <section className='lg:pt-[0px] pt-[0px] lg:pb-[10px] pb-[20px]'>
                
       <div className="grid lg:grid-cols-2 grid-cols-1 items-center pb-[36px] lg:gap-[90px] gap-[30px] max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]">
  
  <div>
    <div className='mb-[15px] w-full flex justify-center items-center rounded-[12px] p-[22px]'>
      <img 
        src="/assets/landascap iner1.png" 
        className='rounded-[12px] '
        
        alt="Trusted cable management and termination solutions provider in the UAE" 
      />
    </div>
  </div>

  <div>
    <ul className="mt-4 grid grid-cols-1 gap-2">
      {[
        "Hard Landscaping",
        "Soft Landscaping",
        "Swimming Pools",
        "Lakes & Ponds",
        "Streams & Cascades",
        "Spas & Health Retreats",
        "Dancing & Interactive Fountains",
      ].map((item, i) => (
        <li
          key={i}
          className="flex items-start gap-3 rounded-lg bg-white px-4 transition"
        >
          <span className="mt-1 text-[#e09e0f] text-sm font-semibold">●</span>
          <span className="text-gray-700 text-[18px] leading-relaxed aplus">
            {item}
          </span>
        </li>
      ))}
    </ul>
  </div>

</div>


             
   <div className='newbg'>

               <div className='max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] overflow-hidden allheader mb-[40px]'>
 
                         <h3>In association with our principals, we provide a range of IP66/67/68 & 69 solutions to cover a complete spectrum of electrical wiring and termination needs.</h3>

               </div>
               </div>

     <div className="max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] pb-[36px]">
  
  <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-[90px] gap-[30px]">

    {/* LEFT – IMAGE (Sticky only on Desktop) */}
    <div className="lg:sticky lg:top-[120px] self-start">
      <div className="mb-[15px] w-full flex justify-center items-center rounded-[12px] p-[22px]">
        <img
          src="/assets/newlac.png" 
          className="rounded-[12px] w-full object-cover ln-img" 
          alt="Trusted cable management and termination solutions provider in the UAE"
        />
      </div>
    </div>

    {/* RIGHT – CONTENT */}
    <div>
      <ul className="mt-4 grid grid-cols-1 gap-2">
        {[
          "IP66 / IP67 / IP68 Weather Proof Enclosures",
          "IP68 Gel Filled Connectors",
          "Re-enterable Gel",
          "Cable Glands & Ventilation Devices",
          "Waterproof Tapes",
          "Wiring Terminals",
          "H07RN-F Rubber Flexibles",
          "Power, Instrumentation & Control Cables",
          "Cable Tray & Conduits",
          "In-Ground Power Unit",
        ].map((item, i) => (
          <li
            key={i}
            className="flex items-start gap-3 rounded-lg  bg-white px-4   transition"
          >
            <span className="mt-2 h-2 w-2 rounded-full bg-[#e09e0f]" />
            <span className="text-gray-700 text-[18px] leading-relaxed font-inter font-[300] aplus">
              {item}
            </span>
          </li>
        ))}
      </ul>

      <Link to="/industries">
        <button className="backbtn mt-6">
          Back To Industries
        </button>
      </Link>
    </div>

  </div>
</div>



                {/* <div className='detail-div-p detail-div-p-2 max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]'>
                    <div className='detail-div-p-div'>
                        <h3>Enclosures</h3>
                        <p> IP66/67/68 rated UV resistant Weather Proof Polycarbonate, Aluminium, FRP & ABS enclosures are offered in various sizes with and without terminals </p>
                    </div>
                    <div className='detail-div-p-div'>
                        <h3>IP68 Gel Filled Connectors</h3>
                        <p>Available in straight and branch formation to suit cables from 0.5mm2 to 6mm2</p>
                    </div>
                    <div className='detail-div-p-div'>
                        <h3>IP68 Bi-component Silicone Gel</h3>
                        <p>Standard pack size of 1liter & 10liter are available with gel colour as light blue </p>
                    </div>
                    <div className='detail-div-p-div'>
                        <h3>Power, Control & Rubber Flexible Cables</h3>
                        <p>LV, Instrumentation, Earthing, Control & Rubber Flexible cables are available to distribute power and control lights & pumps </p>
                    </div>
                    <div className='detail-div-p-div'>
                        <h3>Conduits & Fittings</h3>
                        <p>Rigid & Flexible conduits and accessories for pump room, irrigation and electrical are available in uPVC and galvanised iron</p>
                    </div>
                    <div className='detail-div-p-div'>
                        <h3>Glands, Lugs, Water Proof Tapes & Connectors </h3>
                        <p>Termination, glanding and tapes are available to secure and power the cables & joints safely  </p>
                    </div>
                    <div className='detail-div-p-div'>
                        <h3>Signalling Devices</h3>
                        <p>The offering covers audible, visual, combination devices, call points and grounding systems made from corrosion resistant aluminium or GRP for the usage in gas and dust explosion-hazardous areas.
                        </p>
                    </div>
                    <div className='detail-div-p-div'>
                        <h3>Earthing & Lightning Materials</h3>
                        <p>The range covers early warning systems, early streamer emission, air terminals, down conductors, earthing and exothermic welding products
                        </p>
                    </div>
                    <div className='detail-div-p-div'>
                        <h3>Electrical Accessories</h3>
                        <p>e carry lugs, connectors, grounding, cable tie wraps, labelling materials, tapes, terminals, adhesives, fasteners and more. This helps and support you to quickly and reliably connect, label and secure your electrical wiring.</p>
                    </div>


                    <div className='detail-div-p-div'>
                        <h3>Socket Outlets</h3>
                        <p>We offer a wide range of industrial socket outlets (16A to 600A), ATEX socket outlets, switch-disconnectors to meet various safety issues in industrial environments.</p>
                    </div>
                </div> */}
            </section>

        

        </>
    )
}

export default ProductDetail